export default __webpack_public_path__ + "static/pro-6ab098519dd937f5013ea8ec51b84c15.webp";